import ReadMore from './read-more';
import './read-more.scss';

export default ReadMore;
